import { Link } from "react-router-dom";
import { formatDate } from "../lib/brand";
import { Clock } from "lucide-react";

export default function ArticleCard({ article, size = "md" }) {
  const sizeClasses = {
    lg: "md:text-4xl lg:text-5xl text-3xl",
    md: "text-2xl md:text-2xl",
    sm: "text-xl",
  };

  return (
    <Link to={`/editorial/${article.slug}`}
          className="article-card block group"
          data-testid={`article-card-${article.slug}`}>
      <div className="overflow-hidden border-2 border-[var(--ink)] bg-[var(--ink)] aspect-[16/10] relative">
        <img src={article.hero_image}
             alt={article.title}
             loading="lazy"
             className="w-full h-full object-cover" />
        <div className="absolute top-3 left-3">
          <span className="tape text-[0.7rem]">{article.category}</span>
        </div>
        {article.featured && (
          <div className="absolute bottom-3 left-3">
            <span className="bg-[var(--ink)] text-[var(--paper)] px-2 py-1 text-[0.65rem] font-display uppercase tracking-widest">
              ★ Featured
            </span>
          </div>
        )}
      </div>
      <div className="pt-4">
        <div className="text-kicker mb-2">{article.author} · {formatDate(article.published_at)}</div>
        <h3 className={`text-headline art-title text-[var(--ink)] ${sizeClasses[size]}`}>
          {article.title}
        </h3>
        <p className="text-dek mt-2 text-base line-clamp-2">{article.dek}</p>
        <div className="mt-3 flex items-center gap-2 text-xs font-mono-ed uppercase tracking-widest text-[var(--muted)]">
          <Clock size={12} /> {article.read_minutes} min read
        </div>
      </div>
    </Link>
  );
}
